import BccRwdProductList from 'components/Bcc/BccRwdProductList/BccRwdProductList';

export default BccRwdProductList;
